exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trax-form-control-select[data-v-01451976] li.disabled span.material-icons {\n    display: none !important;\n}\n\n", ""]);

// exports
